package com.anjuros.website.templates.template2.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.toMutableStateList
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template2.components.Template2SectionTitle
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Service
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2ServiceCardStyle
import com.anjuros.website.templates.template2.styles.Template2ServiceColumnStyle
import com.anjuros.website.templates.template2.util.ResKey
import com.anjuros.website.templates.template2.util.Template2ObserverViewportEntered
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.order
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2Service() {
    Box(
        modifier = Modifier
            .id(Template2Section.Service.id)
            .fillMaxSize()
            .backgroundColor(Template2Theme.Background.rgb)
            .padding(top = 130.px, bottom = 100.px),
        contentAlignment = Alignment.Center
    ) {

        val animatedTranslate = remember {
            MutableList(Template2Service.entries.size) { (5).percent }.toMutableStateList()
        }
        val animatedOpacity = remember {
            MutableList(Template2Service.entries.size) { 0.0f }.toMutableStateList()
        }

        Template2Service.entries.forEach { service->
            Template2ObserverViewportEntered(
                sectionId = "services${service.ordinal}",
                distanceFromTop = 700.0
            ) {
                animatedTranslate[service.ordinal] = 0.percent
                animatedOpacity[service.ordinal] = 1.0f
            }
        }

        Column(modifier = Template2ServiceColumnStyle.toModifier()
            .align(Alignment.Center),
            verticalArrangement = Arrangement.spacedBy(30.px),
            horizontalAlignment = Alignment.CenterHorizontally) {

            Template2SectionTitle(
                modifier = Modifier.fillMaxWidth(),
                title = ResKey.TEMPLATE2_SERVICE_TITLE,
                text = ResKey.TEMPLATE2_SERVICE_DESC
            )

            Template2Service.entries.forEachIndexed { index, service ->
                Template2ServiceCard(
                    service = service,
                    reverse = index % 2 != 0,
                    opacity = animatedOpacity[service.ordinal],
                    translate = animatedTranslate[service.ordinal]
                )
            }
        }
    }
}

@Composable
fun Template2ServiceCard(
    service: Template2Service,
    reverse: Boolean,
    opacity:Float,
    translate:CSSLengthOrPercentageNumericValue
) {

    val breakpoint = rememberBreakpoint()

    val imageFirst = reverse && breakpoint >= Breakpoint.MD


    Box(
        modifier = Template2ServiceCardStyle.toModifier()
            .id("services${service.ordinal}")
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent else 80.percent
            )
            .height(
                if (breakpoint >= Breakpoint.MD)
                    240.px
                else
                    460.px
            )
            .borderRadius(12.px)
            .opacity(opacity)
            .translateX(tx=if(reverse) translate*(-1) else translate)
            .transition(
                Transition.of("opacity", 1200.ms),
                Transition.of("translate", 1200.ms)
            )
            .overflow(Overflow.Hidden)
            .backgroundColor(rgb(252, 250, 247))

    ) {

        Row(
            modifier = Modifier
                .fillMaxSize()
                .flexDirection(
                    if (breakpoint >= Breakpoint.MD)
                        FlexDirection.Row
                    else
                        FlexDirection.Column
                ),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {

            //====================================================
            // IMAGE
            //====================================================

            Box(
                modifier = Modifier
                    .flex(
                        if (breakpoint >= Breakpoint.MD) 60.percent else 100.percent
                    )
                    .height(
                        if (breakpoint >= Breakpoint.MD)
                            100.percent
                        else
                            220.px
                    )
                    .position(Position.Relative)
                    .overflow(Overflow.Hidden)
                    .order(
                        if (imageFirst) 0 else 1
                    )
            ) {

                AnjurosImage(
                    modifier = Modifier
                        .fillMaxSize()
                        .objectFit(ObjectFit.Cover)
                        .transition(
                            Transition.of(
                                property = "transform",
                                duration = 300.ms
                            )
                        ),
                    src = service.image,
                    alt = LocalText(service.title)
                )


                //====================================================
                // BLURRED TRANSITION
                //====================================================

                Box(
                    modifier = Modifier
                        .displayIfAtLeast(Breakpoint.LG)
                        .position(Position.Absolute)
                        .top(0.px)
                        .bottom(0.px)
                        .width(120.px)
                        .zIndex(2)

                        .thenIf(
                            imageFirst,
                            Modifier.right(0.px)
                        )
                        .thenIf(!imageFirst,
                            Modifier.left(0.px))
                        .styleModifier {

                            property(
                                "background",
                                if (imageFirst)
                                    "linear-gradient(to left, #FCFAF7, transparent)"
                                else
                                    "linear-gradient(to right, #FCFAF7, transparent)"
                            )

                        }
                )

                Box(
                    modifier = Modifier
                        .displayUntil(Breakpoint.LG)
                        .position(Position.Absolute)
                        .top(0.px)
                        .height(60.px)
                        .fillMaxWidth()
                        .zIndex(2)

                        .styleModifier {

                            property(
                                "background",
                                "linear-gradient(to bottom, #FCFAF7, transparent)"
                            )

                        }
                )
            }


            //====================================================
            // TEXT
            //====================================================

            Column(
                modifier = Modifier
                    .flex(
                        if (breakpoint >= Breakpoint.MD)
                            40.percent
                        else
                            100.percent
                    )
                    .padding(
                        left = 36.px,
                        right = 36.px,
                        top = 24.px,
                        bottom = 24.px
                    )
                    .justifyContent(JustifyContent.Center)
                    .order(
                        if (imageFirst) 1 else 0
                    ),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.Start
            ) {
                

                P(
                    attrs = Modifier
                        .fontSize(28.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Template2Theme.Primary.getColor())
                        .margin(bottom = 10.px)
                        .toAttrs()
                ) {
                    Text(
                        LocalText(service.title)
                    )
                }


                P(
                    attrs = Modifier
                        .fontSize(16.px)
                        .lineHeight(1.5)
                        .color(rgb(90, 90, 90))
                        .margin(0.px)
                        .toAttrs()
                ) {
                    Text(
                        LocalText(service.description)
                    )
                }

            }
        }
    }
}